import { MagentoStockItem } from './magento-stock-item';

export interface MagentoStockItems {
  items: MagentoStockItem[];
  searchCriteria: any;
  totalCount: number;
}
